/**
 * 解析为可放在 `<audio src>` 里的地址。
 * - 相对路径（如 `/audio/xxx.mp3`）会按 Vite `BASE_URL` 加前缀（子路径部署时仍可用）。
 * - 可选 `VITE_AUDIO_BASE_URL` 时拼到该源站（末尾无斜杠）。
 * - 对路径做 `encodeURI`：空格、中文、以及 JSON 里已带 `%20` 的「字面百分号」文件名与静态服务解码规则一致。
 */
export function resolveAudioUrl(relativePath: string): string {
  const remoteBase =
    (import.meta.env.VITE_AUDIO_BASE_URL as string | undefined)?.trim().replace(/\/$/, "") ?? "";
  if (!relativePath) return "";
  if (/^https?:\/\//i.test(relativePath)) return relativePath;

  const path = relativePath.startsWith("/") ? relativePath : `/${relativePath}`;

  let full: string;
  if (remoteBase) {
    full = `${remoteBase}${path}`;
  } else {
    const viteBase = (import.meta.env.BASE_URL ?? "/").replace(/\/$/, "");
    full = viteBase ? `${viteBase}${path}` : path;
  }

  return encodeURI(full);
}
